import * as React from "react"
import { IconProps } from "./IconProps"

export const DownloadIcon = (props: IconProps) => {
  const { color = "currentColor" } = props

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z" fill={color} />
    </svg>
  )
}
